import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { ISequencer } from './ISequencer';
import { RandomUniqueValueOptions } from './RandomUniqueValueOptions';
import { Sequence } from './Sequence';

interface ValueResponse {
    v?: number;
}

class Sequencer implements ISequencer {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    generateRandomUniqueValue(options: RandomUniqueValueOptions): Promise<number | null> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/sequences/random',
            method: HttpMethod.PUT
        },
        {
            n: options.name,
            min: options.minValue,
            max: options.maxValue,
            maxatt: options.maxAttempts,
            break: options.breakMaxToGetValue
        });

        return new Promise<number | null>((resolve, reject) => {
            this.manager
                .get<ValueResponse>(req)
                .then((res) => {
                    if (res && res.v) {
                        resolve(res.v);
                    } else {
                        resolve(null);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }

    getNextId(name: string): Promise<number> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/sequences',
            method: HttpMethod.PUT
        },
        {
            n: name
        });

        return new Promise<number>((resolve, reject) => {
            this.manager
                .get<ValueResponse>(req)
                .then((res) => {
                    if (res && res.v) {
                        resolve(res.v);
                    } else {
                        resolve(0);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve(0);
                })
        });
    }

    list(): Promise<Sequence[]> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/sequences',
            method: HttpMethod.GET
        });

        return new Promise<Sequence[]>((resolve, reject) => {
            this.manager
                .get<Sequence[]>(req)
                .then((res) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve([]);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve([]);
                })
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<ISequencer>('ISequencer', (frm) => {
        return new Sequencer(frm);
    });
}